// Entries in this list MUST BE IN LOWERCASE
export const pagesAndMetadata = {
  '/': {
    title: 'Login',
  },
  '/login': {
    title: 'Login',
  },
  '/catalog/login': {
    title: 'Login',
  },
  '/oidc/session/end': {
    title: 'Logout',
    noRetURL: true,
    isOIDC: true,
  },
  '/oidc/session/end/success': {
    title: 'Logout',
    noRetURL: true,
    isOIDC: true,
  },
  '/interaction': {
    title: 'Login',
    noRetURL: true,
  },
  '/catalog/register': {
    title: 'Register',
    noRetURL: true,
  },
  '/register': {
    title: 'Register',
  },
  '/uam/login': {
    title: 'Login',
  },
  '/uam/email': {
    title: 'Registration Email',
  },
  '/uam/step1': {
    title: 'Registration Step 1',
  },
  '/uam/step2': {
    title: 'Registration Step 2',
  },
  '/uam/instructor-verification': {
    title: 'Instructor Verification',
  },
  '/uam/forgot-password': {
    title: 'Forgot Password',
  },
  '/uam/reset-password': {
    title: 'Reset Password',
    noRetURL: true,
  },
  '/confirm': {
    title: 'Registration Confirmed',
    noRetURL: true,
  },
  '/acceptemail': {
    title: 'Email Updated Successfully',
    noRetURL: true,
  },
  '/profile': {
    title: 'Edit Your Profile',
  },
  '/security-questions': {
    title: 'Please Provide Security Questions and Answers',
  },
  '/error': {
    title: 'Error',
    noRetURLValidation: true,
  },
  '/validate': {
    title: 'Validate Password',
    noRetURL: true,
  },
  '/forgotpassword': {
    title: 'Forgot Password',
    noRetURL: true,
  },
  '/resetpassword': {
    title: 'Reset Password',
    noRetURL: true,
  },
  '/portal': {
    title: 'IAM Portal',
    noRetURL: true,
  },
  '/portal/createaccount': {
    title: 'Create Account',
    noRetURL: true,
  },
  '/portal/users': {
    title: 'IAM Portal Users',
    noRetURL: true,
  },
  '/404': {
    title: 'Page Not Found',
    noRetURL: true,
  },
};

// Copies an object into a version of itself with lowercase keys
// eg: { A: 'Hello', B: 'World' } => { a: 'Hello', b: 'World' }
export const makeLowerCaseKeys = (originalObj) => Object.keys(originalObj).reduce(
  (agg, key) => {
    const newAgg = { ...agg };
    newAgg[key.toLowerCase()] = originalObj[key];

    return newAgg;
  },
  {},
);

export const isReturnURLRequired = (url) => {
  if (!url?.length) { return false; }

  const matchedPage = pagesAndMetadata[url.toLowerCase()];
  return (!!matchedPage
    && (
      !Object.hasOwn(matchedPage, 'noRetURL')
      || !matchedPage.noRetURL
    )
  );
};
